(function() {
    'use strict';
    /*
     * Copyright (c) 2015 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhViewEditTags', ihhViewEditTags);

    /**
     * A directive for displaying tags in read mode and changing them to delete buttons and an add button in edit mode. Intended for use with
     * controllers that derive from {@link ihh-common-web.ViewEditCtrlBase}.
     * @ngdoc directive
     * @name ihh-view-edit-tags
     * @memberOf ihh-common-web
     * @example
     * <ihh-view-edit-tags
     *    control-id="some-id"
     *    edit-flag="isEdit"
     *    is-required="true"
     *    label="Name"
     *    model="foo.name"
     *    model-edit="fooTemp.name">
     * </ihh-view-edit-tags>
     */
    function ihhViewEditTags() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * The HTML id to use for the control and label, for accessibility.
                 * @ngdoc property
                 * @name control-id
                 * @memberOf ihh-common-web.ihh-view-edit-tags
                 */
                controlId: '@',

                /**
                 * The text to display as a label.
                 * @ngdoc property
                 * @name label
                 * @memberOf ihh-common-web.ihh-view-edit-tags
                 */
                label: '@',

                /**
                 * If set, marks the field as required, and in edit mode displayes a visual cue that the value is required.
                 * @ngdoc property
                 * @name is-required
                 * @memberOf ihh-common-web.ihh-view-edit-tags
                 */
                isRequired: '=',

                /**
                 * The scope variable used to track view and edit mode.
                 * @ngdoc property
                 * @name edit-flag
                 * @memberOf ihh-common-web.ihh-view-edit-tags
                 */
                editFlag: '=',

                /**
                 * The kind of the tag to filter by.
                 * @ngdoc property
                 * @name kind
                 * @memberOf ihh-common-web.ihh-view-edit-tags
                 */
                kind: '@',

                /**
                 * The list of all available tags.
                 * @ngdoc property
                 * @name tags
                 * @memberOf ihh-common-web.ihh-view-edit-tags
                 */
                tags: '=',

                /**
                 * The function to add a tag to the modelEdit
                 * @ngdoc property
                 * @name addTag
                 * @memberOf ihh-common-web.ihh-view-edit-tags
                 */
                addTag: '=',

                /**
                 * The function to remove a tag to the modelEdit
                 * @ngdoc property
                 * @name removeTag
                 * @memberOf ihh-common-web.ihh-view-edit-tags
                 */
                removeTag: '=',

                /**
                 * The scope variable used as the model for displaying the text in view mode.
                 * @ngdoc property
                 * @name model
                 * @memberOf ihh-common-web.ihh-view-edit-tags
                 */
                model: '=',

                /**
                 * The scope variable used as the model for the input field when in edit mode.
                 * @ngdoc property
                 * @name model-edit
                 * @memberOf ihh-common-web.ihh-view-edit-tags
                 */
                modelEdit: '='
            },
            templateUrl: 'view-edit/view-edit-tags.tpl.html',
            link: function(scope/*, elem, attrs*/ ) {
                // last chance init here

                scope.closeDropdown = function($event) {
                    $event.target.parentElement.parentElement.parentElement.click();
                };
            }
        };
    }
})();